<template>
  <v-row>
    <v-col>
      <div flat class="settings">
        <v-form ref="formW" @submit.prevent="addIpAddress">
          <v-container fluid>
            <v-row class="mx-0">
              <h2 class="white--text">{{ addHead }}</h2>
            </v-row>
            <v-row class>
              <v-col sm="5">
                <v-text-field
                  class="primarygreen--text"
                  autocomplete="off"
                  v-model="ipAddress"
                  single-line
                  solo
                  flat
                  background-color="#fff !important"
                  label="Enter an IP Address"
                  height="52px"
                  @keyup.enter="addIpAddress"
                ></v-text-field>
              </v-col>
              <v-col sm="2" class="offset-sm-5" align="center">
                <v-btn
                  color="white"
                  tile
                  large
                  height="52px"
                  min-width="150px"
                  @click="addIpAddress"
                  class="primarygreen--text font-weight-black text-uppercase"
                >Add</v-btn>
                <v-btn
                  color="white"
                  height="52px"
                  min-width="150px"
                  @click="addIpAddress"
                  class="primarygreen--text"
                  v-if="saveFailed"
                >Try Again</v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import ValidationHelper from '@/helpers/validationHelper';
export default {
  props: ['addHead', 'clear'],
  data() {
    return {
      ipAddress: '',
      saveFailed: false,
      validationHelper: null
    };
  },
  created () {
    this.validationHelper = new ValidationHelper();
  },
  methods: {
    addIpAddress() {
      if (this.ipAddress !== '') {
        if (this.validateIPaddress(this.ipAddress)) {
          this.$emit('dataSubmit', this.ipAddress);
        } else {
          this.snackbar('error', this.$message.INVALID_IP);
        }
      } else {
        this.snackbar('error', this.$message.IP_EMPTY);
      }
    },
    validateIPaddress(entry) {
      return this.validationHelper.checkVaildIP(entry);
    }
  },
  watch: {
    clear: function(value) {
      if (value) {
        this.ipAddress = '';
      }
    }
  }
};
</script>